import styled from 'styled-components';

export const Container = styled.nav`
  margin: 20px 0 0;

  .step-list {
    display: flex;
    align-items: center;
    gap: 12px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .step-list > li:not(.step-line) {
    flex: 0 0 auto;
    min-width: 0;
  }

  .step-line {
    flex: 1;
    min-width: 16px;
    height: 2px;
    background: #dee2e6;
    border-radius: 1px;
  }

  .step {
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 9px;
    color: #6c757d;
    padding: 0;
    text-align: left;
    min-width: 0;
    font-size: 15px;

    &:hover:not(:disabled) .step-label {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 0;
      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
      border-radius: 4px;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.55;
    }
  }

  .step-circle {
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    border: 1px solid #ced4da;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;

    .material-icons-outlined {
      font-size: 18px;
    }
  }

  .step-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .step-label {
    line-height: 1.25;
    white-space: nowrap;
  }

  .step-text small {
    line-height: 1.2;
    font-size: 13px;
  }

  .step.current {
    font-weight: 600;
    color: #21354a;

    .step-label {
      text-decoration: underline;
    }

    .step-circle {
      background: #007bff;
      border-color: #007bff;
      color: #fff;
    }
  }

  .step.complete .step-circle {
    background: #28a745;
    border-color: #28a745;
    color: #fff;
  }

  .step.pending {
    color: #856404;

    .step-circle {
      background: #fff3cd;
      border-color: #ffc107;
      color: #856404;
    }

    small {
      color: #856404;
    }
  }

  .step-resume {
    color: #007bff;
  }
`;
